import React from "react"
import { Card } from "react-bootstrap"

const Content4 = () => {
  return (
    <Card>
      <Card.Body>
        <Card.Title>Beta Testing</Card.Title>
        <Card.Subtitle className="mb-2 text-muted">Q3 2021 - Q2-2022</Card.Subtitle>
        <Card.Text>Accepting beta customers for testing only.</Card.Text>
      </Card.Body>
    </Card>
  )
}

export default Content4
